import { environment } from './../../environments/environment';
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./auth.service";
import * as Cookies from "js-cookie";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.indexOf(environment.apiUrl + '/api') > -1) {
      if (request.url.indexOf('upload') > -1) {
        request = request.clone({
          setHeaders: {}
        });
      } else {
        let curHeader = request.headers;
        if (curHeader.get('Content-Type') !== 'multipart/form-data') {
          curHeader = curHeader.set('Content-Type', curHeader.get('Content-Type') ? curHeader.get('Content-Type') : 'application/json');
        }
        if (curHeader.get('Content-Type') === 'multipart/form-data') {
          curHeader = curHeader.delete('Content-Type');
        }
        let headerInterceptors = {
          headers: curHeader
        };
        if (Cookies.get(environment.jwtTokenKey)) {
          headerInterceptors['setHeaders'] = {
            Authorization: 'Bearer ' + Cookies.get(environment.jwtTokenKey)
          };
        }
        request = request.clone(headerInterceptors);
      }
    }

    // console.log(request, next);
    return next.handle(request);
  }
}
